module.exports = __webpack_public_path__ + "media/images/costumes/top/wasou/thumbnail-5-e99ce7ce007f42e0089d2e2614436fa5.jpg";